<template>
  <div>
    <modal id="cloneSettingFromDoctor" v-model="modal" :append-to-body="true" :backdrop="false" class="skintestblock"
           size="lg">
      <h4 slot="title" class="smalltitle">Clone Setting From Doctor To {{ toDoctor.fullName }}</h4>

      <div class="profield"><input v-model="keySearch" type="text" @keydown.enter.prevent="loadListDoctor"></div>
      <div class="prolabel" style="padding-top: 5px !important;">
        <button class="btn btn-default" type="button" @click.prevent="loadListDoctor">
          Search
        </button>
      </div>
      <div class="profield" style="width: 99% !important;max-height: 300px;overflow-y: auto">
        <ul v-if="doctors.length" class="itemlisttable searchpatientlist">
          <li class="itemlisthead">
            <div class="item-name" style="width: 30% !important;">FULL NAME</div>
            <div class="item-dob" style="width: 15% !important;">DOB</div>
            <div class="item-created-at" style="width: 15% !important;">CREATED</div>
            <div class="item-action" style="width: 30% !important;">Action</div>
          </li>
          <li v-for="(doctor) in doctors"
              @click.prevent="chooseDoctor(doctor)"
          >
            <div class="item-name" style="width: 30% !important;">
              <div :style="'background-image: url('+ doctor.avatar+')'" class="avatar-user"></div>
              {{ doctor.fullName }}
            </div>
            <div class="item-created-at" style="width: 15% !important;">{{ formatTime(doctor.birthDay) }}</div>
            <div class="item-created-at" style="width: 15% !important;">{{ formatTime(doctor.createdAt) }}</div>
            <div class="item-action" style="width: 30% !important;">
              <label class="inline-checkbox" style="padding-right: 0px !important;">
                <input v-model="doctorChooseId" :value="Number(doctor.id)" name="choose-doctor-import" type="radio"
                       @click="chooseDoctor(doctor)"> Choose
              </label>
            </div>
          </li>
        </ul>
        <span
            v-if="doctors.length === 0">No doctors found
        </span>
      </div>

      <div class="block-data-config" v-if="doctorChooseId" style="width: 99% !important;max-height: 400px;overflow-y: auto">
        <div style="display: block;width: 100%">
          <label class="inline-checkbox">
            <input v-model="selectAll" type="checkbox" @change="selectAllData">
            <strong>Select All</strong>
          </label>
        </div>
        <div v-for="item in listDataConfigs" class="item-data-1">
          <label class="inline-checkbox">
            <input v-model="dataImports" @change="selectData(item)" :value="item.code" type="checkbox">
            <strong>{{ item.name }}</strong>
          </label>
          <template v-if="item.children && item.children.length">
            <div v-for="itemSub in item.children" class="item-data-2">
              <label class="inline-checkbox">
                <input
                    v-model="dataImports"
                    :value="itemSub.code"
                    type="checkbox"
                >
                <strong>{{ itemSub.name }}</strong>
              </label>
              <template v-if="itemSub.children && itemSub.children.length">
                <div v-for="itemSubSub in itemSub.children"
                     class="item-data-3">
                  <label class="inline-checkbox">
                    <input
                        v-model="dataImports"
                        :value="itemSubSub.code"
                        type="checkbox"
                    >
                    <strong>{{ itemSubSub.name }}</strong>
                  </label>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
      <div slot="footer">
        <p v-if="doctorChooseId" style="float: left; width: 100%; text-align: left !important;font-weight: bold">All setups from
          {{ toDoctor.fullName }} will be overwrite by setup from {{ doctorChoose.fullName }}</p>
        <button class="btn btn-default" type="button" @click.prevent="cloneFromDoctor">
          <i v-if="processingStatus" class="fas fa-spinner fa-spin"></i> Import
        </button>
        <button class="btn btn-default" type="button" @click.prevent="closeModal">Close
        </button>
      </div>
    </modal>
  </div>

</template>

<script>
import httpClient from '../../../client'
import CommonMixin from '../../../mixins/general/CommonMixin.vue'

export default {
  name: 'CloneToClinic',
  components: {},
  props: {
    toDoctor: { required: true },
    typeUser: {
      default: 'doctor'
    }
  },
  mixins: [CommonMixin],
  data () {
    return {
      modal: false,
      registeredName: '',
      keySearch: '',
      doctors: [],
      processingStatus: false,
      doctorChooseId: 0,
      doctorChoose: null,
      listDataConfigs: [],
      dataImports: [],
      selectAll: false
    }
  },
  computed: {},
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  mounted () {
    this.modal = true
    this.loadListDataSetup()
  },
  beforeDestroy () {
  },
  methods: {
    selectData(item) {
      const traverse = (node, add) => {
        if (add) {
          if (!this.dataImports.includes(node.code)) {
            this.dataImports.push(node.code);
          }
        } else {
          this.dataImports = this.dataImports.filter(code => code !== node.code);
        }
        if (node.children) {
          node.children.forEach(child => traverse(child, add));
        }
      };
      traverse(item, this.dataImports.includes(item.code));
    },
    selectAllData () {
      if (!this.selectAll) {
        this.dataImports = []
        return
      }
      function flattenData (data) {
        let result = []
        const traverse = (items) => {
          items.forEach(item => {
            result.push(item.code)
            if (item.children) {
              traverse(item.children)
            }
          })
        }
        traverse(data)
        return result
      }

      this.dataImports = flattenData(this.listDataConfigs)
    },
    async loadListDoctor () {
      if (!this.keySearch) {
        return
      }
      this.doctorChooseId = null
      let params = {
        keySearch: this.keySearch,
        typePage: 'LIST_DOCTOR',
        clinicId: this.typeUser === 'clinic' ? this.toDoctor.id : 0
      }
      let response = await httpClient.get(`/users/list-doctor`, { params: params })
      this.isLoading = false
      try {
        if (response.data.s === 200) {
          this.doctors = response.data.data.users ? response.data.data.users : []
        } else {
          this.alertError('Server error when load data clinic. F5 and refresh browser')
        }
      } catch (e) {
        this.isLoading = false
        this.alertException(e)
      }
    },
    async loadListDataSetup () {
      let response = await httpClient.get(`/clinic/list-data-import`, {})
      try {
        if (response.data.s === 200) {
          this.listDataConfigs = response.data.data.listSetupImported ? response.data.data.listSetupImported : []
        }
      } catch (e) {

      }
    },
    chooseDoctor (doctor) {
      this.selectAll = false
      this.dataImports = []
      this.doctorChooseId = Number(doctor.id)
      this.doctorChoose = doctor
    },
    async cloneFromDoctor () {
      if (this.processingStatus) {
        return
      }
      if (!this.doctorChooseId) {
        this.alertError('Please fill out doctor')
        return
      }
      if(!this.dataImports.length) {
        this.alertError('Please choose item to clone data')
        return
      }
      if (this.typeUser === 'clinic') {
        try {
          let data = {
            fromId: this.doctorChooseId,
            toId: this.toDoctor.id,
            dataImports: this.dataImports
          }
          this.processingStatus = true
          let response = await httpClient.post(`/clinic/import-setting-from-doctor`, data)
          this.processingStatus = false
          if (response.data.s === 200) {
            this.closeModal()
            this.$emit('updateCreateId', response.data.idClinicWiki)
          } else {
            this.alertError(response.data.msg)
          }
        } catch (e) {
          this.processingStatus = false
          this.alertError('Server error when set new password ')
        }
      } else {
        // try {
        //   let data = {
        //     fromId: this.doctorChooseId,
        //     toId: this.toDoctor.id
        //   }
        //   this.processingStatus = true
        //   let response = await httpClient.post(`/doctor/clone-from-other-doctor`, data)
        //   this.processingStatus = false
        //   if (response.data.s === 200) {
        //     this.closeModal()
        //     this.$emit('updateCreateId', response.data.idClinicWiki)
        //   } else {
        //     this.alertError(response.data.msg)
        //   }
        // } catch (e) {
        //   this.processingStatus = false
        //   this.alertError('Server error when set new password ')
        // }
      }
    },
    closeModal () {
      this.modal = false
    }
  }
}
</script>
<style>
#cloneSettingFromDoctor .modal-dialog {
  width: 80%;
}
</style>
<style scoped>
.block-data-config {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.item-data-1 {
  flex: 1 1 calc(25% - 10px);
  box-sizing: border-box;
  /*border-top: 1px solid #707070;*/
  /*border-right: 1px solid #707070;*/
  padding-top: 10px;
  padding-bottom: 10px;
}

.item-data-2 {
  margin-left: 15px;
}

.item-data-3 {
  margin-left: 15px;
}
</style>
